import { useComparer } from '@/hooks/useComparer';
import { useEffect, useState } from 'react';

export const useExpandable = (defaultOpen: boolean): [boolean, (open: boolean) => void] => {
  const { expandAll } = useComparer();
  const [open, setOpen] = useState<boolean>(expandAll ?? defaultOpen);

  useEffect(() => {
    expandAll !== undefined && setOpen(expandAll);
  }, [expandAll]);

  return [open, setOpen];
};
